// @ts-ignore
import config from "config";
// @ts-ignore
import React, { Component } from "react";
import { style } from "typestyle";
// @ts-ignore
import { BufferSwitchControl } from "./BufferSwitchControl";
import FlightPlanPageMap from "./FlightPlanPageMap";
import KmlDownloadButton from "./KmlDownloadButton";
import { SiteBoundary } from "../../../apiFacades/csu/site";

type Props = {
  quadcopterKml: string;
  fixedWingKml: string;
  siteBoundary: SiteBoundary;
  siteName: string;
};

type State = {
  activeLayerIsQuadcopter: boolean;
  activeBaseLayerIsSatellite: boolean;
};

export default class FlightPlanViewer extends Component<Props, State> {
  state = {
    activeLayerIsQuadcopter: true,
    activeBaseLayerIsSatellite: true,
  };

  getActiveKmlContent(): string {
    return this.state.activeLayerIsQuadcopter
      ? this.props.quadcopterKml
      : this.props.fixedWingKml;
  }

  render(): JSX.Element {
    return (
      <div>
        <div
          className={style({
            paddingBottom: "20px",
            fontSize: "14px",
            lineHeight: "20px",
          })}
        >
          A drone flight control application requires a user to enter a survey
          area polygon. The coverage should be a bit larger than the site area
          to get good results on the boundaries. You can replicate the extended
          polygon manually in your flight app or import the KML file.
        </div>
        <BufferSwitchControl
          quadcopterIsActive={this.state.activeLayerIsQuadcopter}
          onClick={(quadcopterIsActive: boolean) => {
            this.setState({ activeLayerIsQuadcopter: quadcopterIsActive });
          }}
        />
        <div
          className={style({
            position: "relative",
            width: "100%",
            height: "600px",
          })}
        >
          {this.renderBaseLayersControl()}
          <FlightPlanPageMap
            flightPlanKml={this.getActiveKmlContent()}
            siteBoundary={this.props.siteBoundary}
            baseLayerUrl={
              this.state.activeBaseLayerIsSatellite
                ? `https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=${config.mapboxKey}`
                : "http://{s}.tile.osm.org/{z}/{x}/{y}.png"
            }
          />
        </div>
        <div
          className={style({
            width: "100%",
            marginTop: "24px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          })}
        >
          <KmlDownloadButton
            kmlContent={this.getActiveKmlContent()}
            siteName={this.props.siteName}
            siteBoundaryUpdateTime={this.props.siteBoundary.properties.updated}
          />
        </div>
      </div>
    );
  }

  renderBaseLayersControl(): JSX.Element {
    const { activeBaseLayerIsSatellite } = this.state;
    const imgUrl = activeBaseLayerIsSatellite
      ? "baselayer-map.png"
      : "baselayer-satellite.png";
    return (
      <img
        className={style({
          width: "75px",
          height: "75px",
          cursor: "pointer",
          position: "absolute",
          zIndex: 200,
          borderRadius: "5px",
          top: "10px",
          right: "10px",
          boxShadow:
            "0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23)",
        })}
        src={imgUrl}
        onClick={() => {
          this.setState({
            activeBaseLayerIsSatellite: !activeBaseLayerIsSatellite,
          });
        }}
      />
    );
  }
}
